<template>
  <div>
    <!-- 搜索栏 -->
    <div>
      <search abc="找大会，找视频"></search>
    </div>
    <!-- 轮播图     -->
    <div class="homepage-swipe">
      <!-- <mt-swipe >
        <mt-swipe-item v-for="item in banner" :key="item.id">
          <img :src="'http://static.itdks.com' + item.middlePicture" alt="" @click="bannerDeatil(item.url)">
        </mt-swipe-item>
      </mt-swipe> -->
      <ic-slider :autoplay="3000">
        <ic-slider-item v-for="item in banner" :key="item.id">
          <img :src="item.middlePicture" alt="" @click="bannerDeatil(item.outerUrl,item.id)">
        </ic-slider-item>
      </ic-slider>
      <!-- <wv-swipe :height="200" :auto="1000">
          <wv-swipe-item v-for="item in banner" :key="item.id">
            <img :src="'http://static.itdks.com' + item.middlePicture" alt="" @click="bannerDeatil(item.url)">
          </wv-swipe-item>

        </wv-swipe> -->
      </div>
      <!-- menu -->
      <div class="homepage-menu">
        <ul>
          <li>
            <router-link :to="{name: 'navigation', query: {activity: 'Recommend'}}">
              <img src="./../../assets/img/meet.png" alt="">
              <p>推荐活动</p>
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'navigation', query: {data: 'week'}}">
              <img src="./../../assets/img/menu1.png" alt="">
              <p>本周峰会</p>
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'navigation', query: {sort: 'new'}}">
              <img src="./../../assets/img/menu2.png" alt="">
              <p>最新视频</p>
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'vipvideo', query: {type: 'vip'}}">
              <img src="./../../assets/img/menu3.png" alt="">
              <p>VIP视频</p>
            </router-link>
          </li>
         <!--  <li>
            <router-link :to="{name: 'pptlist'}">
              <img src="./../../assets/img/menu4.png" alt="">
              <p>会议PPT</p>
            </router-link>
          </li> -->
          <li>
            <router-link :to="{name: 'community'}">
              <img src="./../../assets/img/menu5.png" alt="">
              <p>热门社区</p>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- tag -->
      <div class="homepage-tag">
        <div class="tag">
          <ul>
            <li v-for="(item,index) in categoryList" @click="changeState(index)">
              <router-link :to="{name: 'categorydetail',query: {id: item.id}}" href="">{{ item.name }}</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="homepagetab" v-bind:class="{stop: homepageTabStop}">
        <ul>
          <li @click="Live" v-bind:class="{ active: live}">大咖直播</li>
          <li @click="Meet" v-bind:class="{active: meet}">技术峰会</li>
          <li @click="Subject" v-bind:class="{ active: subject}">技术专题</li>
        </ul>
      </div>
      <div class="homepageScroll">
        <scroll-bar :url="url" :uType="1" v-if="url !== 'api/live/zsLiveList?'"></scroll-bar>
        <SubScrollBar :url="url" v-if="url === 'api/live/zsLiveList?'"></SubScrollBar>
      </div>
    </div>
  </template>

  <script>
    import IcSlider from './vue-better-slider/components/slider.vue'
    import IcSliderItem from './vue-better-slider/components/slider-item.vue'
    import SubScrollBar from 'src/components/Commons/SubScrollBars'
    // import storage from 'src/assets/js/common'
    export default {
      data() {
        return {
          uType: '1',
          selected: "",
          banner: [],
          axiosUrl: 'api/subject/getMeetingInfo?mid=', // 列表数据跳转需要的接口地址  包括直播详情 峰会详情 专题详情
          live: false,
          subject: false,
          meet: true,
          url: "api/meeting/getMeetings?sort=new&",
          categoryList: [],
          homepageTabStop: false,
          offsetTop: 0,
          testabc:123,
          images: []
        };
      },
      computed: {
        getId() {
          return this.$store.state.categoryId;
        }
      },
      components: {
        IcSlider,
        IcSliderItem,
        SubScrollBar
      },
      watch: {
        selected(newV) {
          this.$router.push({
            name: newV
          });
        }
      },
      created() {
        this.initData()
        this.getShareInfo()
        // this.get_uid()
      },
      mounted() {
        window.addEventListener('scroll', this.handleScroll)
      },
      methods: {
      // 初始化
      initData() {
        this.$axios.get('api/banner/getBanner?type=APP').then(res => {
          this.banner = res.data.data.bannerList;
          this.banner.forEach(item =>{
            if (item.middlePicture.indexOf('http') == -1) {
              item.middlePicture = item.middlePicture.indexOf('https://') == -1 ? 'https://www.itdks.com/' + item.middlePicture : item.middlePicture;
            }
          })
        });
        this.$axios.get('api/category/getCategory').then(res => {
          let result = res.data.data.categoryList;
          for (var key in result) {
            this.categoryList.push(result[key]);
          }
          this.categoryList = this.categoryList.slice(0, 16);
        });
        window.localStorage.setItem("axiosUrl", this.axiosUrl)
      },
      // 获取状态（是否微信登录以及是否已授权）
      get_uid(){
        var pw='',isWeiXin='',sq_uid=null,nick_name=null,ip='',current_url=null,source_url=null;
        current_url=window.location.href;
        source_url=window.location.href;
        if(this.get('source_url')&&this.get('source_url')!=''){
          source_url=this.get('source_url');
        }
        this.set('source_url',source_url);
        if(this.get('uid')&&this.get('uid')!=''&&this.get('uid')!='null'){
          sq_uid=this.get('uid');
          nick_name=this.get('nick_name');
        }
        else if(this.$route.query.uid&&this.$route.query.uid!=''){
          sq_uid=this.$route.query.uid;
          nick_name=this.$route.query.nick_name;
        }
        this.set('uid',sq_uid);
        // sq_uid=get('uid');
        this.set('nick_name',nick_name);
        // nick_name=get('nick_name');
        this.$axios.get('https://www.itdks.com/Home/My/getWxUid').then(res => {
          if(res.data.status==1){
            isWeiXin=res.data.data.isWeiXin;
            ip=res.data.data.ip;
            // alert(sq_uid+'+'+nick_name+'+'+current_url+'+'+source_url+'+'+isWeiXin+'+'+ip);
            this.send_nick_name(sq_uid,nick_name,current_url,source_url);
            this.test_wechat(isWeiXin,sq_uid);
            // setInterval(() => {
            //   this.test_wechat(isWeiXin,sq_uid);
            // },2000);
          }
          else{
            console.log(res.data.msg);
          }
        })
      },
      // 跳转到微信授权页面
      test_wechat(isWeiXin,sq_uid) {
        if(isWeiXin==true){
          if(sq_uid&&sq_uid!=''&&sq_uid!='null'&&sq_uid!=null){
            return
          }
          else{
            var locationUrl = window.location.href;
            var newurlProbably=locationUrl.replace(/http:\/\/[^\/]*/, "");
            var newurl=this.setBase(newurlProbably);
            var jiami_url='https://www.itdks.com/Home/auth/authBackTest?params='+newurl;
            var weixin_encodeURI='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxdb7ae4d519952e9a&redirect_uri='+jiami_url+'&response_type=code&scope=snsapi_userinfo&state=1&component_appid=wx94aa7c42919766bb#wechat_redirect'; 
            window.location.href=weixin_encodeURI;
          }
        }
        else{
          return
        }
      },
      // 发送name和url等数据给接口
      send_nick_name(sq_uid,nick_name,current_url,source_url){
        this.$axios.post('https://www.itdks.com/Home/Statistics/addUserTodayView', {
          uid:sq_uid,
          nick_name:nick_name,
          current_url:current_url,
          source_url:source_url,
        })
        .then(function (response) {
          console.log('请求成功');
        })
        .catch(function (error) {
          console.log('请求失败');
        });
      },
      // 调用加密函数
      setBase(url){
        let Base64 = require("js-base64").Base64;
        let wx_state = Base64.encode(url);
        return wx_state;
      },
      // 存储数据(字符串)
      set(key,value){
        localStorage.setItem(key,value);
      },
      // 取出数据
      get(key){
      // return JSON.parse(localStorage.getItem(key));
      return localStorage.getItem(key);
    },

    test() {
      this.testabc = 345
    },
    Subject() {
      this.url = 'api/Subject/getSubjects?status=1&';
      this.live = false;
      this.subject = true;
      this.meet = false;
      this.axiosUrl = 'api/live/detail?type=0&id='
      window.localStorage.setItem("axiosUrl", this.axiosUrl)
    },
    Live() {
        this.url = "api/live/zsLiveList?"; // 大咖直播
        this.live = true;
        this.subject = false;
        this.meet = false;
        this.axiosUrl = 'api/subject/getsubjectdetail?id=';
        window.localStorage.setItem("axiosUrl", this.axiosUrl)
      },
      Meet () {
        this.url = 'api/meeting/getMeetings?sort=new&';
        this.live = false;
        this.subject = false;
        this.meet = true;
        this.axiosUrl = 'api/subject/getMeetingInfo?mid=';
        window.localStorage.setItem("axiosUrl", this.axiosUrl)
      },
      bannerDeatil(url,banner_id) {
        var tiaozhuan_url=url;

        if (url.length > 0) {

          if (url.indexOf('http') <= -1) {
            if (url.indexOf('Subject') > -1) { // 专题
              const idIndex = url.indexOf('id');
              const this_id = url.substr(idIndex + 3);
              window.localStorage.setItem("techId", this_id);
              if(this_id==4){
                tiaozhuan_url='/#/topicList?id=4';
              }
              else{
                // tiaozhuan_url='/#/subjectDetail?id='+this_id;
                tiaozhuan_url='https://www.itdks.com/Home/mobile/topic_detail?id='+this_id;
              }
            }
            if (url.indexOf('Meeting') > -1) { // 活动 无直播
              const idIndex = url.indexOf('id');
              const this_id = url.substr(idIndex + 3);
              tiaozhuan_url='https://www.itdks.com/Home/mobile/detail?id='+this_id+'&type=meet';
            }
          } 

          // 点击banner请求接口
          const from_url = window.parent.document.referrer;
          var ClickBanner_uid='0';
          if(localStorage.getItem('uid')&&localStorage.getItem('uid')!=''){
            ClickBanner_uid=localStorage.getItem('uid');
          }
          this.$axios.post('https://www.itdks.com/Api/banner/bannerHit', {
            uid:ClickBanner_uid,
            out_url:tiaozhuan_url,
            banner_id:banner_id,
            from_url:from_url,
            ip:'',
            source:'mobile'
          })
          .then(function (response) {
            console.log('请求成功');
          })
          .catch(function (error) {
            console.log('请求失败');
          });
          if (url.indexOf('http') > -1) {
            setTimeout(function(){window.location.href = url},1000);
          } else {
            const idIndex = url.indexOf('id');
            const id = url.substr(idIndex + 3);
            window.localStorage.setItem("techId", id);
            if (url.indexOf('Subject') > -1) { // 专题
              if(id==4){
                setTimeout(function(){window.location.href='/#/topicList?id=4'},1000);
                return;
              }
              else{
                // setTimeout(function(){window.location.href='/#/subjectDetail?id='+id},1000);
                setTimeout(function(){window.location.href='https://www.itdks.com/Home/mobile/topic_detail?id='+id},1000);
                return;
              }
              this.$router.push({path: '/OldSubject', query: {aid: id}});
            }
            if (url.indexOf('Activity') > -1) { // 活动 有直播
              this.$router.push({path: '/Technicaltopic', query: {aid: id}});
            }
            if (url.indexOf('Meeting') > -1) { // 活动 无直播
              setTimeout(function(){window.location.href='https://www.itdks.com/Home/mobile/detail?id='+id+'&type=meet'},1000);
              return;
            }
            if (url.indexOf('Course') > -1) { // 课程
              this.$router.push({path: '/Technicaltopic', query: {aid: id}});
            }
            if (url.indexOf('Live') > -1) { // 大咖直播
              setTimeout(function(){window.location.href='https://www.itdks.com/Home/Live/detail?id='+id},1000);
              return;
            }
          }
        }
      },
      
      changeState(i) {
        this.$store.state.categoryId = i;
      }
    }
  };
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}

input {
  border: none;
  outline-style: none;
}

li {
  list-style: none;
}

a {
  text-decoration: none;
}

.homepage-swipe {
  position: relative;
  top: 86px;
  img{
    height:420px;
    width:100%;
  }
}

.mint-swipe-item {
  height: 420px !important;
  position: relative;
  img {
    height:100%;
    width: 100%;
    position: absolute;
  }
}

.mint-swipe {
  height: 420px !important;
}

.mint-swipe .mint-swipe-items-wrap {
  height: 420px !important;
}

.homepage-menu {
  margin-top: 100px;
}

.homepage-menu ul {
  padding: 20px 28px 25px 28px;
  display: flex;
  box-sizing: border-box;
  border-bottom: 10px solid #f2f6f2; /*no*/
  li {
    flex: 1;
    display: inline-block;
    text-align: center;
    a {
      text-align: center;
      color: #535353;
      img {
        height: 73px;
        width:auto;
        margin-bottom: 16px;
      }
    }
  }
}

.homepage-tag {
  padding: 31px 26px;
  box-sizing: border-box;
  background-image: -webkit-linear-gradient(to right, #3079ec, #003095);
  background-image: linear-gradient(to right, #3079ec, #003095);
  h2 {
    font-weight: 300;
    color: #fff;
    font-size: 32px; /*px*/
    height: 54px;
  }
  .tag ul {
    height: 280px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;
    li {
      display: inline-block;
      width: 148px;
      height: 52px;
      border-radius: 22px;
      text-align: center;
      line-height: 54px;
      border: 1px solid #eeeeee;
      margin-bottom: 24px;
      a {
        color: #eeeeee;
        font-size: 24px; /*px*/
      }
    }
  }
}

.homepagetab ul {
  /* width: 750px; */
  padding: 9px 29px 0 29px;
  box-sizing: border-box;
  list-style: none;
  display: flex;
  background: #f3f5f2 url(./../../assets/img/dian_bg.png) repeat-x left bottom;
  li {
    width: 220px;
    height: 80px;
    text-align: center;
    line-height: 80px;
    flex: 1;
    font-size: 26px;
  }
  .active {
    color: #3e92cb;
    background: #3e92cb;
    background: url(./../../assets/img/selectbg.png);
    background-size: 100%;
    z-index: 10;
  }
}

.stop {
  position: fixed;
  top: 80px;
  width: 750px;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage/HomePage.vue